import { useTranslation } from "@coworker/locales";
import { useCustomAllSelectOption } from "../../shared/filters/utils/useAllSelectOption";
import {
  FilterType,
  FilterValue,
  InputType,
  RowVisibility,
  SelectFilter,
  StringFilterValue,
} from "../../shared/filters/types/filter";
import { useTaskTypeFilterConfig } from "./useTaskTypeFilterConfig";
import { GROUP_BY_ID, TASK_TYPE_ID } from "../constants/filterIds";
import useFlag, { FLAGS } from "@coworker/app/src/hooks/useFlag";

export function useGroupByFilter(filterValues: FilterValue[]): SelectFilter {
  const { t } = useTranslation();
  const enableAddonOrdersV2 = useFlag(FLAGS.ENABLE_ADDON_ORDERS_V2);
  const defaultValue = { filterId: GROUP_BY_ID, value: "" };
  const { hasConfig, config } = useTaskTypeFilterConfig(
    GROUP_BY_ID,
    filterValues
  );

  let enabled: boolean;

  if (hasConfig) {
    // Config found - use it (takes precedence)
    enabled = config !== null;
  } else {
    // No config found - use existing logic unchanged
    const taskTypeValue = filterValues.find(
      (filter) => filter.filterId === TASK_TYPE_ID
    );
    const taskTypeValueValue =
      (taskTypeValue as StringFilterValue)?.value ?? "";

    // Support both v1 (pickAndRefill, refill) and v2 (addonOrder) task types
    const addonTaskTypes = enableAddonOrdersV2
      ? ["addonOrder"]
      : ["pickAndRefill", "refill"];
    enabled = addonTaskTypes.includes(taskTypeValueValue);
  }

  return useCustomAllSelectOption(
    {
      inputType: InputType.Select,
      filterType: FilterType.Filter,
      id: GROUP_BY_ID,
      title: t("groupByTitleString"),
      options: [
        {
          value: "hfbPickup",
          title: t("hfbPickupLocationString"),
          dependsOnFilterId: TASK_TYPE_ID,
        },
        {
          value: "hfbRefill",
          title: t("hfbRefillLocationString"),
          dependsOnFilterId: TASK_TYPE_ID,
        },
      ],
      enabled,
      defaultValue,
      rowVisibility: RowVisibility.PillOnly,
    },
    t("noGroupingString")
  );
}
